import * as fromDatatype from '../datatype-library/index';

export interface app_common_address_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  address_line_1: fromDatatype.TextDatatypeInterface;
  address_line_2: fromDatatype.TextDatatypeInterface;
  address_line_3: fromDatatype.TextDatatypeInterface;
  address_line_4: fromDatatype.TextDatatypeInterface;
  address_line_5: fromDatatype.TextDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  longitude: fromDatatype.NumericDatatypeInterface;
  latitude: fromDatatype.NumericDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_common_address_RowClass implements app_common_address_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  address_line_1: fromDatatype.TextDatatypeInterface;
  address_line_2: fromDatatype.TextDatatypeInterface;
  address_line_3: fromDatatype.TextDatatypeInterface;
  address_line_4: fromDatatype.TextDatatypeInterface;
  address_line_5: fromDatatype.TextDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  longitude: fromDatatype.NumericDatatypeInterface;
  latitude: fromDatatype.NumericDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
